import { Box, OutlinedInput, Typography } from '@mui/material'

import { color } from 'config/color'
import { FormLabel, GenericDialog, MButton } from 'components'
import { useState } from 'react'
import { ReviewLinkAccountDialog } from './ReviewLinkAccountDialog'
import { useSnackbar } from 'notistack'

interface ILinkAccountDialog {
  open: boolean
  onClose: () => void
  mainAccountNumber?: string
  refreshLinkedAccounts: () => Promise<void>
  linkedAccounts: any
}

export const LinkAccountDialog = ({
  open,
  onClose,
  mainAccountNumber,
  refreshLinkedAccounts,
  linkedAccounts
}: ILinkAccountDialog): JSX.Element => {
 const { enqueueSnackbar } = useSnackbar()


  const [accountsToLink, setAccountsToLink] = useState('')
  const [showReviewDialog, setShowReviewDialog] = useState(false)

  const handleChange = (event: any): void => {
    setAccountsToLink(event.target.value)
  }

  const handleSubmit = async (): Promise<void> => {
    const isLinkingOwnAccountNumber = accountsToLink.trim() === mainAccountNumber
    const hasBeenLinkedAlready = linkedAccounts.some((item: any) => item.accountId === accountsToLink.trim())
    if (isLinkingOwnAccountNumber) {
      enqueueSnackbar('You cannot link your own account number.', { variant: 'error' })
      return
    } else if (hasBeenLinkedAlready) {
      enqueueSnackbar(`Account ${accountsToLink.trim()} is already linked.`, { variant: 'error' })
      return
    }
    setShowReviewDialog(true)
  }

  return (
    <Box>
      <GenericDialog open={open} onClose={onClose}>
        <Box display="flex" flexDirection="column" gap={2}>
          <Box display="flex" flexDirection="column">
            <Typography color={color.grey[900]} fontWeight={500} fontSize={24}>
              Link Account
            </Typography>

            <Typography color={color.grey[700]} fontWeight={400} fontSize={16}>
              Here you can link one account. Enter the required
              information
            </Typography>

            <Typography color={color.grey[700]} fontWeight={400} fontSize={16} mt={1} mb={1}>
              <Typography component="span" fontWeight={700}>Main Account Number:</Typography> {mainAccountNumber}
            </Typography>
          </Box>

          <Box display="flex" flexDirection="column" gap={1}>
              <FormLabel textcolor={color.grey[700]}>
                Account Number
              </FormLabel>
              <Box display="flex" flexDirection="row">
                <OutlinedInput
                  placeholder="Enter 10-digit Account Id"
                  onChange={(e) => {
                    // Only allow digits and max 10 digits
                    const sanitized = e.target.value.replace(/\D/g, '').slice(0, 10)
                    handleChange({ target: { value: sanitized } })
                  }}
                  value={accountsToLink}
                  type="text"
                  fullWidth
                  inputProps={{ maxLength: 10, inputMode: 'numeric', pattern: '[0-9]*' }}
                  error={accountsToLink.length > 0 && accountsToLink.length !== 10}
                />
              </Box>
          </Box>

          <Box display="flex" flexDirection="column" gap={1}>
            <MButton
              type="button"
              variant="contained"
              rounded="true"
              texttransform="none"
              onClick={handleSubmit}
              disabled={accountsToLink.trim() === '' || accountsToLink.length !== 10}
            >
              Link Account
            </MButton>

            <MButton
              variant="outlined"
              type="button"
              rounded="true"
              texttransform="none"
              onClick={onClose}
            >
              Go Back
            </MButton>
          </Box>
        </Box>
      </GenericDialog>

      {showReviewDialog && (
        <ReviewLinkAccountDialog
          open={showReviewDialog}
          onClose={() => {
            setShowReviewDialog(!showReviewDialog)
          }}
          onCloseLinkDialog={onClose}
          accountsToLink={[accountsToLink]}
          refreshLinkedAccounts={refreshLinkedAccounts}
        />
      )}
    </Box>
  )
}
